import React, { useEffect, useState } from 'react';
import { Card, Grid, Paper } from '@mui/material';
import { AppContext } from '../../context/AppContext';
import BakeasyHeaderLabel from '../../components/lables/BakeasyHeaderLabel';
import { useLocation, useNavigate } from 'react-router-dom';
import BakeasyDatePicker from '../../components/common/BakeasyDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { BakeasyImgSelector } from '../../components/common/BakeasyImgSelect';
import BakeasySwitch from '../../components/common/BakeasySwitch';
import { BakeasySelectLabel } from '../../components/dropdowns/BakeasySelect';
import {
  STATUS_ARRAY,
  BACKORDER,
  BILL_TO_ARRAY,
  BILL_TO_ARRAY_WITHOUT_CHAINSTORE,
  STORE_CATEGORY_ARRAY,
} from '../../constants/Constants';
import { t } from 'i18next';
import BakeasyDivider from '../../components/common/BakeasyDivider';
import { BakeasyAppBar } from '../../components/common/BakeasyAppBar';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  addStore,
  downloadStoreDetails,
  fetchStoreById,
  modifyStore,
  storesState,
} from '../../redux_store/slices/storesSlice';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import {
  BakeasyButtonCancel,
  BakeasyButtonUpdate,
  BakeasyButtonCreate,
} from '../../components/buttons/BakeasyButton';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import * as Button from '../../components/buttons/BakeasyButtons';
import * as Dropdown from '../../components/dropdowns/BakeasySelect';
import { uploadFile } from '../../ApiServices/StoresService';
import BakeasyTextField from '../../components/textfields/BakeasyTextField';
import BakeasyLabelText from '../../components/lables/BakeasyLabelText';
import {
  prepareMobileNumber,
  preparePostalCode,
  prepareDemicalNumber,
  validateField,
} from '../../utils/ValidationUtils';
import * as Regex from '../../constants/Regex';
import {
  BakeasyAutoCompleteCountry,
  BakeasyAutoCompletePaymentMethod,
  BakeasyAutoCompletePaymentTerms,
  BakeasyAutoCompleteState,
  BakeasyAutoCompleteTax,
} from '../../components/dropdowns/BakeasyAutoComplete';
import {
  clearTaxesState,
  fetchTaxes,
  taxesState,
} from '../../redux_store/slices/taxesSlice';
import { BakeasyAutoCompleteShippingMethod } from '../../components/dropdowns/BakeasyAutoComplete';
import {
  fetchShippingMethods,
  shippingMethodsState,
} from '../../redux_store/slices/shippingMethodsSlice';
import {
  countryState,
  fetchCountries,
} from '../../redux_store/slices/countriesSlice';
import {
  clearStatesState,
  fetchStates,
  statesState,
} from '../../redux_store/slices/statesSlice';
import { dropdownDataState } from '../../redux_store/slices/dropdownDataSlice';
import i18n from '../../languages/languages';
import { hideLoader, showLoader } from '../../redux_store/slices/loaderSlice';
import { fetchAllStores } from '../../redux_store/slices/messageStoreSlice';
import { useRef } from 'react';
import { wait } from '@testing-library/user-event/dist/utils';

export const AddEditStore = (props: any) => {
  const formRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isView, setIsView] = useState<boolean>(false);
  const [storeData, setStoreData] = useState<any>();

  const [registrationDate, setRegistrationDate] = useState<Dayjs | null>(null);
  const [selectedLanguage, setSelectedLanguage] = useState<string>('');
  const [accountingCode, setAccountingCode] = useState<any>('');
  const [selectedCategory, setSelectedCategory] = useState<any>('B2B');
  const [storeName, setStoreName] = useState<any>('');
  const [userName, setUserName] = useState<any>('');
  const [password, setPassword] = useState<any>('');
  const [showPassword, setShowPassword] = useState(false);
  const [legalName, setLegalName] = useState<any>('');
  const [differentLegalName, setDifferentLegalName] = useState<any>(
    i18n.language === 'fr' ? 'Non' : 'No'
  );

  const [storeId, setStoreId] = useState<any>('');
  const [storeAddress, setStoreAddress] = useState<any>('');
  const [storeCity, setStoreCity] = useState<any>('');
  const [storeState, setStoreState] = useState<any>(null);
  const [storePostCode, setStorePostCode] = useState<any>('');
  const [storeCountry, setStoreCountry] = useState<any>(null);
  const [storeDiscount, setStoreDiscount] = useState<any>();
  const [storeEmail, setStoreEmail] = useState<any>('');
  const [storeWork, setStoreWork] = useState<any>('');
  const [supplierTax1, setSupplierTax1] = useState<any>('');
  const [supplierTax2, setSupplierTax2] = useState<any>('');

  const [firstName, setFirstName] = useState<any>('');
  const [lastName, setLastName] = useState<any>('');
  const [email, setEmail] = useState<any>('');
  const [work, setWork] = useState<any>('');
  const [mobile, setMobile] = useState<any>('');

  const [contactOneFirstName, setContactOneFirstName] = useState<any>('');
  const [contactOneLastName, setContactOneLastName] = useState<any>('');
  const [contactOneEmail, setContactOneEmail] = useState<any>('');
  const [contactOneWork, setContactOneWork] = useState<any>('');
  const [contactOneMobile, setContactOneMobile] = useState<any>('');

  const [contactTwoFirstName, setContactTwoFirstName] = useState<any>('');
  const [contactTwoLastName, setContactTwoLastName] = useState<any>('');
  const [contactTwoEmail, setContactTwoEmail] = useState<any>('');
  const [contactTwoWork, setContactTwoWork] = useState<any>('');
  const [contactTwoMobile, setContactTwoMobile] = useState<any>('');

  const [accountingFirstName, setAccountingFirstName] = useState<any>('');
  const [accountingLastName, setAccountingLastName] = useState<any>('');
  const [accountingEmail, setAccountingEmail] = useState<any>('');
  const [accountingWork, setAccountingWork] = useState<any>('');
  const [accountingMobile, setAccountingMobile] = useState<any>('');

  const [isChainStore, setIsChainStore] = useState<boolean>(false);
  const [chainStoreName, setChainStoreName] = useState<any>('');
  const [parentAddress, setParentAddress] = useState<any>('');
  const [parentCity, setParentCity] = useState<any>('');
  const [parentState, setParentState] = useState<any>(null);
  const [parentPostCode, setParentPostCode] = useState<any>('');
  const [parentCountry, setParentCountry] = useState<any>(null);
  const [parentEmailId, setParentEmailId] = useState<any>('');
  const [parentWork, setParentWork] = useState<any>('');

  const [billTo, setBillTo] = useState<any>('');
  const [billToName, setBillToName] = useState<any>('');
  const [billToCompanyName, setBillToCompanyName] = useState<any>('');
  const [billToAddress, setBillToAddress] = useState<any>('');
  const [billToCity, setBillToCity] = useState<any>('');
  const [billToPostCode, setBillToPostCode] = useState<any>('');
  const [billToCountry, setBillToCountry] = useState<any>(null);
  const [billToState, setBillToState] = useState<any>(null);

  // const [taxNumber1, setTaxNumber1] = useState<any>('');
  // const [taxNumber2, setTaxNumber2] = useState<any>('');
  const [selectedTaxRate1, setSelectedTaxRate1] = useState<any>('');
  const [selectedTaxRate2, setSelectedTaxRate2] = useState<any>('');
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>('');
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState<any>('');
  const [selectedBillTo, setSelectedBillTo] = useState<any>('');
  const [name, setName] = useState<any>('');
  const [companyName, setCompanyName] = useState<any>('');
  const [address, setAddress] = useState<any>('');
  const [city, setCity] = useState<any>('');
  const [postCode, setPostCode] = useState<any>('');
  const [country, setCountry] = useState<any>('');
  const [state, setState] = useState<any>('');
  const [selectedStatus, setSelectedStatus] = useState<any>('');
  const [description, setDescription] = useState<any>('');
  const [selectedShippingCharge, setSelectedShippingCharge] = useState<any>(
    i18n.language === 'fr' ? 'Non' : 'No'
  );
  const [selectedShippingCalculation, setSelectedShippingCalculation] =
    useState<any>('');
  const [shippingCharges, setShippingCharges] = useState<any>('');
  const [quantity, setQuantity] = useState<any>('');
  const [price, setPrice] = useState<any>('');
  const [note, setNote] = useState<any>('');
  const [selectedStoreLogoFile, setSelectedStoreLogoFile] = useState<
    File | string | null
  >(null);
  const [selectedBackorder, setSelectedBackorder] = useState<any>('');

  const [selectedShipTo, setSelectedShipTo] = useState<any>('');
  const [shipToName, setShipToName] = useState<any>('');
  const [shipToCompanyName, setShipToCompanyName] = useState<any>('');
  const [shipToAddress, setShipToAddress] = useState<any>('');
  const [shipToCity, setShipToCity] = useState<any>('');
  const [shipToPostCode, setShipToPostCode] = useState<any>('');
  const [shipToCountry, setShipToCountry] = useState<any>(null);
  const [shipToState, setShipToState] = useState<any>('');

  const [preferredShippingMethod, setPreferredShippingMethod] =
    useState<any>('');
  const [selectedPreferredShippingMethod, setSelectedPreferredShippingMethod] =
    useState<any>('');

  let { loading, error, value, rowsPerPage, pageNo, selectedValue } =
    useAppSelector(storesState);
  let _taxesState = useAppSelector(taxesState);
  let _shippingMethodsState = useAppSelector(shippingMethodsState);
  let _countryState = useAppSelector(countryState);
  let _statesState = useAppSelector(statesState);
  let _dropdownDataState = useAppSelector(dropdownDataState);
  const pickupStateName = storeData?.shipToInfo?.state || '';

  useEffect(() => {
    setIsEdit(location?.state?.isEdit);
    setIsView(location?.state?.isView);

    if (location?.state?.isEdit === true || location?.state?.isView === true) {
      fetchData(location?.state?._id);
    }

    dispatch(fetchShippingMethods({ page: 1, limit: 5, search: '' }));
    dispatch(fetchCountries({ page: 1, limit: 5, search: '' }));
  }, []);

  useEffect(() => {
    if (selectedValue) {
      setStoreData(selectedValue);
      setData(selectedValue);
    }
  }, [selectedValue]);

  useEffect(() => {
    if (error) {
      navigate(-1);
    }
  }, [error]);

  useEffect(() => {
    if (selectedShipTo !== 'Pickup') return;
    if (!shipToCountry) return;
    const states = _statesState?.value?.data;
    if (!states?.length) return;
    if (!pickupStateName) return;

    const stateObj = states.find(
      (st: any) =>
        st?.stateName?.toLowerCase() === pickupStateName?.toLowerCase()
    );

    if (stateObj) {
      setShipToState(stateObj);
    }
  }, [
    selectedShipTo,
    shipToCountry,
    _statesState?.value?.data,
    pickupStateName,
  ]);

  const fetchData = async (_id: any) => {
    try {
      dispatch(fetchStoreById({ id: _id }));
    } catch (error) {}
  };

  async function setData(data: any) {
    setStoreId(data?.storeNumber);
    setAccountingCode(data?.accountingCode);
    setSelectedLanguage(data?.defaultLanguage);
    setSelectedCategory(data?.storeCategory);
    setStoreName(data?.storeName);
    setUserName(data?.userName);
    setLegalName(data?.legalName);
    if (data?.legalName && data?.legalName !== data?.storeName) {
      setDifferentLegalName(i18n.language === 'fr' ? 'Oui' : 'Yes');
    } else {
      setDifferentLegalName(i18n.language === 'fr' ? 'Non' : 'No');
    }
    setStoreAddress(data?.storeAddress?.address);
    setStoreCity(data?.storeAddress?.city);
    setStoreState(
      data?.storeAddress?.state
        ? { stateName: data?.storeAddress?.state }
        : null
    );

    if (data?.storeAddress?.country && _countryState?.value?.data?.length > 0) {
      let temp: any = _countryState.value?.data?.find(
        (item: any) => item?.countryName === data?.storeAddress?.country
      );

      if (temp !== undefined) {
        setStoreCountry(temp);
        await dispatch(
          fetchStates({ page: 1, limit: 100, countryId: temp?._id })
        );
        await dispatch(
          fetchTaxes({ page: 1, limit: 10, countryId: temp?._id })
        );
      } else {
        setStoreCountry(
          data?.storeAddress?.country
            ? { countryName: data?.storeAddress?.country }
            : null
        );
      }
    }

    setSupplierTax1(data?.supplierTax1);
    setSupplierTax2(data?.supplierTax2);
    setStoreWork(data?.storeWork);
    setStoreEmail(data?.storeEmail);

    setStorePostCode(data?.storeAddress?.zipCode);
    setStoreDiscount(data?.storeDiscount);
    setSelectedBackorder(
      data?.backOrder
        ? i18n.language === 'fr'
          ? 'Oui'
          : 'Yes'
        : i18n.language === 'fr'
          ? 'Non'
          : 'No'
    );

    setContactOneFirstName(data?.contact1?.firstName);
    setContactOneLastName(data?.contact1?.lastName);
    setContactOneEmail(data?.contact1?.email);
    setContactOneWork(data?.contact1?.work);
    setContactOneMobile(data?.contact1?.mobile);

    setContactTwoFirstName(data?.contact2?.firstName);
    setContactTwoLastName(data?.contact2?.lastName);
    setContactTwoEmail(data?.contact2?.email);
    setContactTwoWork(data?.contact2?.work);
    setContactTwoMobile(data?.contact2?.mobile ?? '');

    setAccountingFirstName(data?.contactAccounting?.firstName);
    setAccountingLastName(data?.contactAccounting?.lastName);
    setAccountingEmail(data?.contactAccounting?.email);
    setAccountingWork(data?.contactAccounting?.work);
    setAccountingMobile(data?.contactAccounting?.mobile);

    setIsChainStore(Boolean(data?.chainStore));
    setChainStoreName(data?.chainStoreDetail?.chainStoreName);
    setBillTo(data?.chainStoreDetail?.billTo);
    setParentAddress(data?.chainStoreDetail?.parentAddress);
    setParentCity(data?.chainStoreDetail?.parentCity);
    setParentPostCode(data?.chainStoreDetail?.parentPostCode);
    setParentCountry(
      data?.chainStoreDetail?.parentCountry
        ? { countryName: data?.chainStoreDetail?.parentCountry }
        : null
    );
    setParentState(
      data?.chainStoreDetail?.parentState
        ? { stateName: data?.chainStoreDetail?.parentState }
        : null
    );
    setParentEmailId(data?.chainStoreDetail?.parentEmailId);
    setParentWork(data?.chainStoreDetail?.parentWork);

    setSelectedBillTo(data?.billTo);
    setBillToName(data?.billToInfo?.name);
    setBillToCompanyName(data?.billToInfo?.companyName);
    setBillToAddress(data?.billToInfo?.companyAddress);
    setBillToCity(data?.billToInfo?.city);
    setBillToState(
      data?.billToInfo?.state ? { stateName: data?.billToInfo?.state } : null
    );
    setBillToCountry(
      data?.billToInfo?.country
        ? { countryName: data?.billToInfo?.country }
        : null
    );
    setBillToPostCode(data?.billToInfo?.zipCode);

    setSelectedShipTo(data?.shipTo);
    setShipToName(data?.shipToInfo?.name);
    setShipToCompanyName(data?.shipToInfo?.companyName);
    setShipToAddress(data?.shipToInfo?.companyAddress);
    setShipToCity(data?.shipToInfo?.city);
    setShipToState(
      data?.shipToInfo?.state ? { stateName: data?.shipToInfo?.state } : null
    );
    setShipToCountry(
      data?.shipToInfo?.country
        ? { countryName: data?.shipToInfo?.country }
        : null
    );
    setShipToPostCode(data?.shipToInfo?.zipCode);

    setSelectedTaxRate1(
      data?.taxes?.rate1 ? { taxName: data?.taxes?.rate1 } : null
    );
    setSelectedTaxRate2(
      data?.taxes?.rate2 ? { taxName: data?.taxes?.rate2 } : null
    );

    setSelectedPaymentMethod(
      data?.payment?.method
        ? { paymentMethod: { ...data?.payment?.method } }
        : null
    );
    setSelectedPaymentTerm(
      data?.payment?.terms
        ? { paymentTerms: { ...data?.payment?.terms } }
        : null
    );

    setSelectedShippingCharge(
      data?.shippingCharges
        ? i18n.language === 'fr'
          ? 'Oui'
          : 'Yes'
        : i18n.language === 'fr'
          ? 'Non'
          : 'No'
    );
    setSelectedShippingCalculation(data?.shippingRateType);
    setShippingCharges(data?.shippingRate);

    // if (data?.preferredShippingMethod) {
    //   let includes: any = PREFERRED_SHIPPING_METHOD_ARRAY?.find(
    //     (item: any) => item?.id === data?.preferredShippingMethod
    //   );

    //   if (includes) {
    //     setSelectedPreferredShippingMethod(data?.preferredShippingMethod);
    //   } else {
    //     setSelectedPreferredShippingMethod('Other');
    //   }

    //   setPreferredShippingMethod(data?.preferredShippingMethod);
    // }

    setSelectedPreferredShippingMethod(
      data?.preferredShippingMethod
        ? { methodName: data?.preferredShippingMethod }
        : null
    );

    setSelectedStatus(data?.status);
    setDescription(data?.description);
    setSelectedStoreLogoFile(data.storeLogo);
  }

  const checkValidity = (): boolean => {
    // if (!validateField(dispatch, 'ACCOUNTING_CODE', accountingCode, Regex.accountingCode)) {
    //   return false;
    // }
    if (
      accountingCode !== undefined &&
      accountingCode !== '' &&
      !validateField(
        dispatch,
        'ACCOUNTING_CODE',
        accountingCode,
        formRef,
        Regex.accountingCode
      )
    ) {
      return false;
    }
    // if (!validateField(dispatch, 'LANGUAGE', selectedLanguage)) {
    //   return false;
    // }
    if (!validateField(dispatch, 'CATEGORY', selectedCategory, formRef)) {
      return false;
    }
    if (
      !validateField(dispatch, 'STORE_NAME', storeName, formRef, Regex.name)
    ) {
      return false;
    }

    if (
      !validateField(dispatch, 'USERNAME', userName, formRef, Regex.username)
    ) {
      return false;
    }

    if (!isEdit) {
      if (!validateField(dispatch, 'PASSWORD', password, formRef)) {
        return false;
      }
    }

    // if (
    //   differentLegalName !== 'No' &&
    //   !validateField(dispatch, 'LEGAL_NAME', legalName, formRef, Regex.name)
    // ) {
    //   return false;
    // }
    if (
      differentLegalName !== 'No' &&
      differentLegalName !== 'Non' &&
      !validateField(dispatch, 'LEGAL_NAME', legalName, formRef, Regex.name)
    ) {
      return false;
    }

    if (!validateField(dispatch, 'STORE_COUNTRY', storeCountry, formRef)) {
      return false;
    }
    if (!validateField(dispatch, 'STORE_STATE', storeState, formRef)) {
      return false;
    }
    if (
      !validateField(
        dispatch,
        'STORE_CITY',
        storeCity,
        formRef,
        Regex.onlyAlphabets
      )
    ) {
      return false;
    }
    if (!validateField(dispatch, 'STORE_ADDRESS', storeAddress, formRef)) {
      return false;
    }
    if (
      !validateField(
        dispatch,
        'STORE_POSTAL_CODE',
        storePostCode,
        formRef,
        storeCountry?.countryName === 'USA'
          ? Regex.usaPostCode
          : Regex.canadaPostCode
      )
    ) {
      return false;
    }
    if (
      storePostCode !== undefined &&
      storePostCode !== '' &&
      !validateField(
        dispatch,
        'STORE_POSTAL_CODE',
        storePostCode,
        formRef,
        storeCountry?.countryName === 'USA'
          ? Regex.usaPostCode
          : Regex.canadaPostCode
      )
    ) {
      return false;
    }

    // if (!validateField(dispatch, 'DISCOUNT_PER', storeDiscount, Regex.onlyNumeric)) {
    //   return false;
    // }
    // if (
    //   storeDiscount !== undefined &&
    //   storeDiscount !== '' &&
    //   !validateField(dispatch, 'DISCOUNT_PER', storeDiscount, Regex.onlyNumeric)
    // ) {
    //   return false;
    // }
    // if (!validateField(dispatch, 'BACKORDER', selectedBackorder)) {
    //   return false;
    // }
    // if (
    //   storeEmail !== undefined &&
    //   storeEmail !== '' &&
    //   !validateField(dispatch, 'STORE_EMAIL', storeEmail, formRef, Regex.emailId)
    // ) {
    //   return false;
    // }
    // if (
    //   storeWork !== undefined &&
    //   storeWork !== '' &&
    //   !validateField(dispatch, 'STORE_MOBILE', storeWork, formRef, Regex.mobile)
    // ) {
    //   return false;
    // }

    if (
      !validateField(
        dispatch,
        'FIRST_NAME',
        contactOneFirstName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }
    if (
      !validateField(
        dispatch,
        'LAST_NAME',
        contactOneLastName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }

    if (
      !validateField(
        dispatch,
        'EMAIL_ID',
        contactOneEmail,
        formRef,
        Regex.emailId
      )
    ) {
      return false;
    }
    // if (!validateField(dispatch, 'MOBILE', contactOneMobile, Regex.mobile)) {
    //   return false;
    // }
    if (
      contactOneMobile !== undefined &&
      contactOneMobile !== '' &&
      contactOneMobile !== null &&
      !validateField(
        dispatch,
        'MOBILE',
        contactOneMobile,
        formRef,
        Regex.mobile
      )
    ) {
      return false;
    }

    if (
      !validateField(dispatch, 'WORK', contactOneWork, formRef, Regex.mobile)
    ) {
      return false;
    }
    // if (!contactTwoFirstName || !ValidateInput(Regex.name, contactTwoFirstName)) {
    //   let msg = `${t('FIRST_NAME')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }
    if (
      contactTwoFirstName !== undefined &&
      contactTwoFirstName !== '' &&
      !validateField(
        dispatch,
        'FIRST_NAME',
        contactTwoFirstName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }
    // if (!contactTwoLastName || !ValidateInput(Regex.name, contactTwoLastName)) {
    //   let msg = `${t('LAST_NAME')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }
    if (
      contactTwoLastName !== undefined &&
      contactTwoLastName !== '' &&
      !validateField(
        dispatch,
        'LAST_NAME',
        contactTwoLastName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }
    // if (!contactTwoEmail || !ValidateInput(Regex.emailId, contactTwoEmail)) {
    //   let msg = `${t('EMAIL')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }
    if (
      contactTwoEmail !== undefined &&
      contactTwoEmail !== '' &&
      !validateField(
        dispatch,
        'EMAIL_ID',
        contactTwoEmail,
        formRef,
        Regex.emailId
      )
    ) {
      return false;
    }
    // if (!contactTwoMobile || !ValidateMobile(contactTwoMobile)) {
    //   let msg = `${t('MOBILE')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }
    if (
      contactTwoMobile !== undefined &&
      contactTwoMobile !== '' &&
      contactTwoMobile !== null &&
      !validateField(
        dispatch,
        'MOBILE',
        contactTwoMobile,
        formRef,
        Regex.mobile
      )
    ) {
      return false;
    }
    // if (!contactTwoWork || !ValidateMobile(contactTwoWork)) {
    //   let msg = `${t('MOBILE')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }
    if (
      contactTwoWork !== undefined &&
      contactTwoWork !== '' &&
      contactTwoWork !== null &&
      !validateField(dispatch, 'MOBILE', contactTwoWork, formRef, Regex.mobile)
    ) {
      return false;
    }
    // if (!validateField(dispatch, 'FIRST_NAME', accountingFirstName, Regex.name)) {
    //   return false;
    // }

    if (
      accountingFirstName !== undefined &&
      accountingFirstName !== '' &&
      !validateField(
        dispatch,
        'FIRST_NAME',
        accountingFirstName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }

    // if (!validateField(dispatch, 'LAST_NAME', accountingLastName, Regex.name)) {
    //   return false;
    // }
    if (
      accountingLastName !== undefined &&
      accountingLastName !== '' &&
      !validateField(
        dispatch,
        'LAST_NAME',
        accountingLastName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }

    // if (!validateField(dispatch, 'EMAIL', accountingEmail, Regex.emailId)) {
    //   return false;
    // }
    if (
      accountingEmail !== undefined &&
      accountingEmail !== '' &&
      !validateField(
        dispatch,
        'EMAIL_ID',
        accountingEmail,
        formRef,
        Regex.emailId
      )
    ) {
      return false;
    }
    // if (!validateField(dispatch, 'MOBILE', accountingMobile, Regex.mobile)) {
    //   return false;
    // }
    if (
      accountingMobile !== undefined &&
      accountingMobile !== '' &&
      accountingMobile !== null &&
      !validateField(
        dispatch,
        'MOBILE',
        accountingMobile,
        formRef,
        Regex.mobile
      )
    ) {
      return false;
    }
    // if (!validateField(dispatch, 'WORK', accountingWork, Regex.mobile)) {
    //   return false;
    // }
    if (
      accountingWork !== undefined &&
      accountingWork !== '' &&
      accountingWork !== null &&
      !validateField(dispatch, 'MOBILE', accountingWork, formRef, Regex.mobile)
    ) {
      return false;
    }

    if (isChainStore) {
      if (
        !validateField(
          dispatch,
          'CHAIN_STORE_NAME',
          chainStoreName,
          formRef,
          Regex.name
        )
      ) {
        return false;
      }
      if (
        !validateField(
          dispatch,
          'PARENT_COUNTRY',
          parentCountry?.countryName,
          formRef,
          Regex.onlyAlphabets
        )
      ) {
        return false;
      }
      if (
        !validateField(
          dispatch,
          'PARENT_STATE',
          parentState?.stateName,
          formRef,
          Regex.onlyAlphabets
        )
      ) {
        return false;
      }
      if (!validateField(dispatch, 'PARENT_ADDRESS', parentAddress, formRef)) {
        return false;
      }
      if (
        !validateField(
          dispatch,
          'PARENT_CITY',
          parentCity,
          formRef,
          Regex.onlyAlphabets
        )
      ) {
        return false;
      }

      if (
        !validateField(
          dispatch,
          'PARENT_POSTAL_CODE',
          parentPostCode,
          formRef,
          parentCountry?.countryName === 'USA'
            ? Regex.usaPostCode
            : Regex.canadaPostCode
        )
      ) {
        return false;
      }

      if (
        !validateField(
          dispatch,
          'PARENT_EMAIL_ID',
          parentEmailId,
          formRef,
          Regex.emailId
        )
      ) {
        return false;
      }
      if (
        !validateField(
          dispatch,
          'PARENT_WORK_NUMBER',
          parentWork,
          formRef,
          Regex.mobile
        )
      ) {
        return false;
      }
    }
    // if (!validateField(dispatch, 'BILL_TO', selectedBillTo)) {
    //   return false;
    // }
    // if (!validateField(dispatch, 'BILL_TO_NAME', billToName, Regex.name)) {
    //   return false;
    // }
    if (
      billToName !== undefined &&
      billToName !== '' &&
      !validateField(dispatch, 'BILL_TO_NAME', billToName, formRef, Regex.name)
    ) {
      return false;
    }
    // if (!validateField(dispatch, 'COMPANY_NAME', billToCompanyName, Regex.name)) {
    //   return false;
    // }
    if (
      billToCompanyName !== undefined &&
      billToCompanyName !== '' &&
      !validateField(
        dispatch,
        'COMPANY_NAME',
        billToCompanyName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }
    // if (!validateField(dispatch, 'ADDRESS', billToAddress)) {
    //   return false;
    // }
    // if (!validateField(dispatch, 'CITY', billToCity, Regex.onlyAlphabets)) {
    //   return false;
    // }
    // if (!validateField(dispatch, 'STATE', billToState, Regex.onlyAlphabets)) {
    //   return false;
    // }
    if (
      billToPostCode !== undefined &&
      billToPostCode !== '' &&
      !validateField(
        dispatch,
        'POSTAL_CODE',
        billToPostCode,
        formRef,
        billToCountry?.countryName === 'USA'
          ? Regex.usaPostCode
          : Regex.canadaPostCode
      )
    ) {
      return false;
    }
    // if (!validateField(dispatch, 'POSTAL_CODE', billToPostCode, Regex.postCode)) {
    //   return false;
    // }
    // if (!validateField(dispatch, 'COUNTRY', billToCountry, Regex.onlyAlphabets)) {
    //   return false;
    // }

    // if (!validateField(dispatch, 'RATE1', selectedTaxRate1)) {
    //   return false;
    // }
    // if (!validateField(dispatch, 'RATE2', selectedTaxRate2)) {
    //   return false;
    // }

    // if (!validateField(dispatch, 'TAX_NUMBER1', taxNumber1)) {
    //   return false;
    // }
    // if (!validateField(dispatch, 'TAX_NUMBER2', taxNumber2)) {
    //   return false;
    // }
    // if (!selectedPaymentMethod) {
    //   let msg = `${t('METHODS')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }
    // if (!selectedPaymentTerm) {
    //   let msg = `${t('TERMS')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }
    // if (!validateField(dispatch, 'METHODS', selectedPaymentMethod)) {
    //   return false;
    // }
    // if (!validateField(dispatch, 'TERMS', selectedPaymentTerm)) {
    //   return false;
    // }

    if (!validateField(dispatch, 'STATUS', selectedStatus, formRef)) {
      return false;
    }
    // if (!validateField(dispatch, 'DESCRIPTION', description)) {
    //   return false;
    // }

    if (!validateField(dispatch, 'SHIP_TO', selectedShipTo, formRef)) {
      return false;
    }
    if (selectedShipTo == 'Pickup') {
      if (!validateField(dispatch, 'NAME', shipToName, formRef, Regex.name)) {
        return false;
      }
      if (
        !validateField(
          dispatch,
          'COMPANY_NAME',
          shipToCompanyName,
          formRef,
          Regex.name
        )
      ) {
        return false;
      }

      if (!validateField(dispatch, 'COUNTRY', shipToCountry, formRef)) {
        return false;
      }
      if (!validateField(dispatch, 'STATE', shipToState, formRef)) {
        return false;
      }
      if (
        !validateField(
          dispatch,
          'CITY',
          shipToCity,
          formRef,
          Regex.onlyAlphabets
        )
      ) {
        return false;
      }
      if (!validateField(dispatch, 'ADDRESS', shipToAddress, formRef)) {
        return false;
      }

      if (
        !validateField(
          dispatch,
          'POSTAL_CODE',
          shipToPostCode,
          formRef,
          shipToCountry?.countryName === 'USA'
            ? Regex.usaPostCode
            : Regex.canadaPostCode
        )
      ) {
        return false;
      }
    }
    if (selectedShippingCharge) {
      if (
        selectedShippingCharge === 'Yes' ||
        selectedShippingCharge === 'Oui'
      ) {
        if (
          !validateField(
            dispatch,
            'SHIPPING_CALCULATION',
            selectedShippingCalculation
          )
        ) {
          return false;
        }

        if (
          !validateField(
            dispatch,
            'SHIPPING_CHARGES',
            shippingCharges,
            formRef,
            Regex.decimalNumber
          )
        ) {
          return false;
        }
      }
    } else {
      let msg = `${t('SHIPPING_CHARGE')} ${t('IS_REQUIRED')}`;
      dispatch(showErrorSnackbar({ message: msg }));
      return false;
    }

    if (
      !validateField(
        dispatch,
        'PREFERRED_SHIPPING_METHOD',
        selectedPreferredShippingMethod,
        formRef
      )
    ) {
      return false;
    }

    // if (
    //   !validateField(
    //     dispatch,
    //     'PREFERRED_SHIPPING_METHOD',
    //     preferredShippingMethod,
    //     Regex.onlyAlphabets
    //   )
    // ) {
    //   return false;
    // }

    return true;
  };

  async function onSubmit() {
    if (!checkValidity()) {
      return;
    }
    let storeLogoUrl = undefined;
    if (selectedStoreLogoFile instanceof File) {
      dispatch(showLoader({ message: t('UPLOADING_LOGO') }));
      storeLogoUrl = await uploadFile(selectedStoreLogoFile, 'storeLogo');
      dispatch(hideLoader());
    }

    let payload = {
      accountingCode: accountingCode,
      defaultLanguage: selectedLanguage === '' ? 'English' : selectedLanguage,
      storeCategory: selectedCategory,
      storeName: storeName,
      userName: userName,
      legalName:
        differentLegalName === 'Yes' || differentLegalName === 'Oui'
          ? legalName
          : storeName,
      storeAddress: {
        address: storeAddress,
        city: storeCity,
        state: storeState?.stateName,
        zipCode: storePostCode,
        country: storeCountry?.countryName,
      },
      storeEmail: storeEmail,
      storeWork: storeWork,
      supplierTax1: supplierTax1,
      supplierTax2: supplierTax2,
      // storeDiscount: storeDiscount,

      storeDiscount: storeDiscount === '' ? 0 : storeDiscount,
      backOrder:
        selectedBackorder === 'Yes' || selectedBackorder === 'Oui'
          ? true
          : false,
      contact1: {
        firstName: contactOneFirstName,
        lastName: contactOneLastName,
        email: contactOneEmail,
        mobile: contactOneMobile?.toString(),
        work: contactOneWork ? contactOneWork?.toString() : '',
      },
      contact2: {
        firstName: contactTwoFirstName ?? '',
        lastName: contactTwoLastName ?? '',
        email: contactTwoEmail ?? '',
        mobile: contactTwoMobile ? contactTwoMobile?.toString() : '',
        work: contactTwoWork ? contactTwoWork?.toString() : '',
      },
      // ...(contactTwoFirstName ||
      // contactTwoLastName ||
      // contactTwoEmail ||
      // contactTwoMobile ||
      // contactTwoWork
      //   ? {
      //       contact2: {
      //         firstName: contactTwoFirstName ?? '',
      //         lastName: contactTwoLastName ?? '',
      //         email: contactTwoEmail ?? '',
      //         mobile: contactTwoMobile ?? '',
      //         work: contactTwoWork ?? ''
      //       }
      //     }
      //   : {}),
      contactAccounting: {
        firstName: accountingFirstName,
        lastName: accountingLastName,
        email: accountingEmail,
        // mobile: accountingMobile,
        mobile: accountingMobile ? accountingMobile?.toString() : '',
        work: accountingWork ? accountingWork?.toString() : '',
      },
      chainStore: isChainStore,
      billTo: selectedBillTo,
      billToInfo: {
        name: billToName,
        companyName: billToCompanyName,
        companyAddress: billToAddress,
        city: billToCity,
        zipCode: billToPostCode,
        state: billToState?.stateName,
        country: billToCountry?.countryName,
      },
      payment: {
        method: {
          ...selectedPaymentMethod?.paymentMethod,
          createdDate: undefined, // Remove  explicitly
          modifiedDate: undefined, // Remove  explicitly
        },
        terms: {
          ...selectedPaymentTerm?.paymentTerms,
          createdDate: undefined, // Remove  explicitly
          modifiedDate: undefined, // Remove  explicitly}
        },
      },
      taxes: {
        rate1: selectedTaxRate1?.taxName,
        rate2: selectedTaxRate2?.taxName,
      },
      shippingCharges:
        selectedShippingCharge === 'Yes' || selectedShippingCharge === 'Oui'
          ? true
          : false,
      status: selectedStatus,
      description: description,
      preferredShippingMethod: selectedPreferredShippingMethod?.methodName,
      shipTo: selectedShipTo,
      shipToInfo: {
        name: shipToName,
        companyName: shipToCompanyName,
        companyAddress: shipToAddress,
        city: shipToCity,
        zipCode: shipToPostCode,
        state: shipToState?.stateName,
        country: shipToCountry?.countryName,
      },
      logoId: storeLogoUrl ? storeLogoUrl.data.id : undefined,
    };

    let detailsPayload = {};

    if (selectedShippingCharge === 'Yes' || selectedShippingCharge === 'Oui') {
      detailsPayload = {
        ...payload,
        shippingRateType: selectedShippingCalculation,
        shippingRate: shippingCharges,
      };
    } else {
      detailsPayload = { ...payload };
    }

    if (isChainStore) {
      detailsPayload = {
        ...detailsPayload,
        chainStoreDetail: {
          chainStoreName: chainStoreName,
          parentAddress: parentAddress,
          parentCity: parentCity,
          parentState: parentState?.stateName,
          parentPostCode: parentPostCode,
          parentCountry: parentCountry?.countryName,
          parentEmailId: parentEmailId,
          parentWork: parentWork ? parentWork.toString() : '',
        },
      };
    }

    if (isEdit) {
      let newPayload: any = { ...detailsPayload, id: location?.state?._id };
      if (password !== '') {
        newPayload = { ...newPayload, password: password };
      }
      let response: any = await dispatch(modifyStore(newPayload));
      if (response?.payload?.status === 200) {
        navigate(-1);
      }
    } else {
      let newPayload = { ...detailsPayload, password: password };
      let response: any = await dispatch(addStore(newPayload));
      if (response?.payload?.status === 200) {
        dispatch(fetchAllStores({ page: 1, limit: 10 }));
        navigate(-1);
      }
    }
  }

  function setBillToData(billToValue: string) {
    switch (billToValue) {
      case 'ChainStore':
        if (isChainStore) {
          setBillToName(chainStoreName);
          setBillToCompanyName(chainStoreName);
          setBillToAddress(parentAddress);
          setBillToCity(parentCity);
          setBillToState(parentState);
          setBillToCountry(parentCountry);
          setBillToPostCode(parentPostCode);
        } else {
          clearBillTo();
        }
        break;
      case 'Store':
        setBillToName(storeName);
        setBillToCompanyName(storeName);
        setBillToAddress(storeAddress);
        setBillToCity(storeCity);
        setBillToState(storeState);
        setBillToCountry(storeCountry);
        setBillToPostCode(storePostCode);
        break;
      case 'Other':
        clearBillTo();
        break;
      default:
        clearBillTo();
        break;
    }
  }

  function handleChainStoreCheck(isChainStoreChecked: boolean) {
    if (!isChainStoreChecked) {
      setChainStoreName('');
      setParentAddress('');
      setParentCity('');
      setParentState('');
      setParentPostCode('');
      setParentCountry('');
      setParentEmailId('');
      setParentWork('');
    }
    if (!isChainStoreChecked && selectedBillTo === 'Chain Store') {
      clearBillTo();
    }
  }

  function clearBillTo() {
    setBillToName('');
    setBillToCompanyName('');
    setBillToAddress('');
    setBillToCity('');
    setBillToState('');
    setBillToCountry('');
    setBillToPostCode('');
  }

  function openCancelConfirmDialog() {
    myContext.setConfirmDialog({
      type: 'cancel',
      open: true,
      title: t('CANCEL_CONFIRMATION'),
      onYesClick: (event: any, param: string | undefined) => {
        navigate(-1);
      },
    });
  }
  // function setShipToData(shipToValue: string) {
  //   switch (shipToValue) {
  //     case 'Store':
  //       setShipToName(storeName);
  //       setShipToCompanyName(storeName);
  //       setShipToAddress(storeAddress);
  //       setShipToCity(storeCity);
  //       setShipToState(storeState);
  //       setShipToCountry(storeCountry);
  //       setShipToPostCode(storePostCode);
  //       break;
  //     case 'Other':
  //       clearShipTo();
  //       break;
  //     default:
  //       clearShipTo();
  //       break;
  //   }
  // }

  async function setShipToData(shipToValue: string) {
    switch (shipToValue) {
      case 'Store':
        setShipToName(storeName);
        setShipToCompanyName(storeName);
        setShipToAddress(storeAddress);
        setShipToCity(storeCity);
        setShipToState(storeState);
        setShipToCountry(storeCountry);
        setShipToPostCode(storePostCode);
        break;
      case 'Pickup':
        setShipToName(storeData?.shipToInfo?.name || '');
        setShipToCompanyName(storeData?.shipToInfo?.companyName || '');
        setShipToAddress(storeData?.shipToInfo?.companyAddress || '');
        setShipToCity(storeData?.shipToInfo?.city || '');
        setShipToPostCode(storeData?.shipToInfo?.zipCode || '');

        const countryObj = _countryState?.value?.data?.find(
          (c: any) =>
            c?.countryName?.toLowerCase() ===
            storeData?.shipToInfo?.country?.toLowerCase()
        );

        if (countryObj) {
          handleShipToCountrySelect(countryObj);
          const stateObj = _statesState?.value?.data?.find(
            (s: any) =>
              s?.stateName?.toLowerCase() ===
              storeData?.shipToInfo?.state?.toLowerCase()
          );
          setShipToCountry(countryObj);
          setShipToState(stateObj);
        }
        break;
      case 'Other':
        clearShipTo();
        break;
      default:
        clearShipTo();
        break;
    }
  }

  function clearShipTo() {
    setShipToName('');
    setShipToCompanyName('');
    setShipToAddress('');
    setShipToCity('');
    setShipToState('');
    setShipToCountry('');
    setShipToPostCode('');
  }

  function openAddTaxDialog(data: any) {
    return myContext.setDialog({
      open: true,
      title: 'ADD_TAX',
      dialogContent: {
        pageName: 'AddTax',
        params: { ...data, storeCountry },
        onBack: async () => {
          await dispatch(
            fetchTaxes({ page: 1, limit: 10, countryId: storeCountry?._id })
          );
        },
      },
    });
  }

  function openImageDialog(pageName: string, title: string, imgUrl: any) {
    return myContext.setDialog({
      open: true,
      title,
      dialogContent: { pageName, imgUrl, title },
    });
  }

  function getMenus() {
    return (
      <Grid>
        {isView && (
          <div className="tableOptions">
            <Button.Edit
              onClick={(event: any) => {
                setIsEdit(true);
                setIsView(false);
              }}
            />

            <Button.Print
              onClick={function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): void {
                dispatch(
                  downloadStoreDetails({
                    id: location?.state?._id,
                    downloadType: 'pdf',
                  })
                );
              }}
            />

            {/* <Button.Export
              onClick={function(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
                dispatch(downloadStoreDetails({ id: location?.state?._id, downloadType: 'csv' }));
              }}
            /> */}
          </div>
        )}
      </Grid>
    );
  }

  function openConfirmDialogMesssageValidation() {
    myContext.setConfirmDialog({
      open: true,
      type: 'confirm-validation-message',
      title: t('CONFIRMATION'),
      message: t(
        'YOU_MUST_COMPLETE_ALL_REQUIRED_FEILDS_OR_CHANGES_WILL_BE_LOST'
      ),
      onNoClick: (event: any) => {},
      onYesClick: (event: any, param: string | undefined) => {
        navigate(-1);
      },
    });
  }

  function openAddShippingMethodDialog(data: any) {
    return myContext.setDialog({
      open: true,
      title: 'ADD_SHIPPING_METHOD',
      dialogContent: {
        pageName: 'AddShippingMethod',
        params: data,
        onBack: async () => {
          await dispatch(fetchShippingMethods({ page: 1, limit: 5 }));
        },
      },
    });
  }

  async function handleStoreCountrySelect(country: any) {
    setStoreState(null);
    setSelectedTaxRate1(null);
    setSelectedTaxRate2(null);
    dispatch(clearStatesState());
    dispatch(clearTaxesState());

    if (country === undefined || country === null) {
      setStoreCountry(null);
      return;
    }

    setStoreCountry(country);
    let payload: any = { page: 1, limit: 100, countryId: country?._id };
    await dispatch(fetchStates(payload));
    await dispatch(fetchTaxes(payload));
  }

  async function handleParentCountrySelect(country: any) {
    setParentState(null);
    dispatch(clearStatesState());

    if (country === undefined || country === null) {
      setParentCountry(null);
      return;
    }

    setParentCountry(country);
    let payload: any = { page: 1, limit: 100, countryId: country?._id };
    await dispatch(fetchStates(payload));
  }

  async function handleBillToCountrySelect(country: any) {
    setBillToState(null);
    dispatch(clearStatesState());

    if (country === undefined || country === null) {
      setBillToCountry(null);
      return;
    }

    setBillToCountry(country);
    let payload: any = { page: 1, limit: 100, countryId: country?._id };
    await dispatch(fetchStates(payload));
  }

  async function handleShipToCountrySelect(country: any) {
    setShipToState(null);
    dispatch(clearStatesState());

    if (country === undefined || country === null) {
      setShipToCountry(null);
      return;
    }

    setShipToCountry(country);
    let payload: any = { page: 1, limit: 100, countryId: country?._id };
    await dispatch(fetchStates(payload));
  }

  function getRegexPatternForPostalCode(country: string): RegExp {
    if (country === 'Canada') {
      return Regex.canadaPostCode;
    } else if (country === 'USA') {
      return Regex.usaPostCode;
    }
    return Regex.canadaPostCode;
  }

  function getMaxLengthForPostalCode(country: string): number {
    if (country === 'Canada') {
      return 7;
    } else if (country === 'USA') {
      return 10;
    }
    return 7;
  }

  function addStoreUI() {
    return (
      <div ref={formRef}>
        <Grid>
          <Grid item>
            <BakeasyAppBar
              title={t(
                isEdit ? 'EDIT_STORE' : isView ? 'STORE_DETAILS' : 'ADD_STORE'
              )}
              onBackClick={() => {
                openConfirmDialogMesssageValidation();
              }}
              menus={getMenus()}
            />
          </Grid>

          <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
            <Grid container>
              <BakeasyHeaderLabel message={'STORE_DETAILS'} />
            </Grid>

            <Grid container spacing={2} pl={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyDatePicker
                  label={t('DATE_REGISTERED')}
                  value={
                    registrationDate ? registrationDate : dayjs(new Date())
                  }
                  disabled={true}
                  required={true}
                />
              </Grid>

              {(isEdit || isView) && (
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.StoreId disabled={true} value={storeId} />
                </Grid>
              )}

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.AccountingCode
                  disabled={isView}
                  placeHolder={t('ENTER_ACCOUNTING_CODE')}
                  required={false}
                  value={accountingCode}
                  onChange={(event: any) => {
                    setAccountingCode(event?.target?.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Dropdown.BakeasySelectLanguage
                  disabled={isView}
                  value={selectedLanguage}
                  onChange={(e: any) => {
                    setSelectedLanguage(e.target.value);
                  }}
                  required={false}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                {/* <BakeasySelectLabel */}
                <Dropdown.Category
                  disabled={false}
                  required={true}
                  // label={t('CATEGORY')}
                  // placeholder={t('SELECT_CATEGORY')}
                  // size="small"
                  // statusOptions={categoryArray}
                  options={STORE_CATEGORY_ARRAY}
                  // fullWidth={true}
                  value={selectedCategory}
                  onChange={(event: any) => {
                    setSelectedCategory(event?.target?.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Name
                  disabled={isView}
                  label={t('STORE_NAME')}
                  value={storeName}
                  onChange={(event: any) => {
                    setStoreName(event?.target?.value);
                  }}
                  placeHolder={t('ENTER_STORE_NAME')}
                  required={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Username
                  disabled={isEdit || isView}
                  value={userName}
                  onChange={(event: any) => {
                    setUserName(event.target.value);
                  }}
                  required={true}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Password
                  required={!isEdit}
                  value={password}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setPassword(event.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Dropdown.YesNo
                  disabled={isView}
                  label={t('DIFFERENT_LEGAL_NAME')}
                  placeholder={t('SELECT_DIFFERENT_LEGAL_NAME')}
                  value={differentLegalName}
                  onChange={(event: any) => {
                    setDifferentLegalName(event?.target?.value);
                    setLegalName('');
                  }}
                  required={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Name
                  disabled={
                    differentLegalName === 'Yes' || differentLegalName === 'Oui'
                      ? false
                      : true
                  }
                  label={t('LEGAL_NAME')}
                  value={
                    differentLegalName === 'Yes' || differentLegalName === 'Oui'
                      ? legalName
                      : storeName
                  }
                  maxLength={100}
                  onChange={
                    differentLegalName === 'Yes' || differentLegalName === 'Oui'
                      ? (event: any) => setLegalName(event?.target?.value)
                      : undefined
                  }
                  required={true}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyAutoCompleteCountry
                  label={'STORE_COUNTRY'}
                  value={storeCountry}
                  options={_countryState.value?.data}
                  required={true}
                  onChange={(newValue: any) => {
                    // if (typeof newValue === 'string' && newValue?.length === 0) {
                    //   dispatch(fetchCountries({ page: 1, limit: 5 }));
                    // }

                    // if (typeof newValue === 'string' && newValue?.length > 2) {
                    //   dispatch(fetchCountries({ page: 1, limit: 5, search: newValue }));
                    // }

                    if (typeof newValue === 'object') {
                      handleStoreCountrySelect(newValue);
                      setStorePostCode('');
                    }

                    if (newValue === null) {
                      setStoreCountry(null);
                      setStorePostCode('');
                      //dispatch(fetchCountries({ page: 1, limit: 5 }));
                    }
                  }}
                />
                {/* <TextField.Country
                disabled={isView}
                label={t('STORE_COUNTRY')}
                value={storeCountry}
                onChange={(event: any) => {
                  setStoreCountry(event.target.value);
                }}
              /> */}
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                {/* <TextField.State
                disabled={isView}
                label={t('STORE_STATE')}
                value={storeState}
                onChange={(event: any) => {
                  setStoreState(event.target.value);
                }}
              /> */}
                <BakeasyAutoCompleteState
                  // label="STORE_STATE"
                  // label={storeCountry?.countryName === 'Canada' ? 'STORE_PROVINCE' : 'STORE_STATE'}
                  label={'STORE_STATE'}
                  required={true}
                  disabled={storeCountry === null}
                  value={storeState}
                  options={_statesState.value?.data}
                  onChange={async (newValue: any) => {
                    if (typeof newValue === 'object') {
                      setStoreState(newValue);
                    }
                    if (newValue === null) {
                      setStoreState(null);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.City
                  disabled={isView}
                  required={true}
                  label={t('STORE_CITY')}
                  value={storeCity}
                  onChange={(event: any) => {
                    setStoreCity(event.target.value);
                  }}
                  placeHolder={t('ENTER_STORE_CITY')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Address
                  disabled={isView}
                  required={true}
                  label={t('STORE_ADDRESS')}
                  value={storeAddress}
                  onChange={(event: any) => {
                    setStoreAddress(event.target.value);
                  }}
                  placeHolder={t('ENTER_STORE_ADDRESS')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Pincode
                  disabled={isView}
                  label={t('STORE_POSTAL_CODE')}
                  placeHolder={t('ENTER_STORE_POSTAL_CODE')}
                  helperMessage={t('PLEASE_ENTER_VALID_STORE_POSTAL_CODE')}
                  value={storePostCode}
                  // onChange={(event: any) => {
                  //   setStorePostCode(preparePostalCode(event.target.value));
                  // }}
                  required={true}
                  maxLength={getMaxLengthForPostalCode(
                    storeCountry?.countryName
                  )}
                  regexPattern={getRegexPatternForPostalCode(
                    storeCountry?.countryName
                  )}
                  onChange={(event: any) => {
                    setStorePostCode(
                      preparePostalCode(
                        event.target.value,
                        storeCountry?.countryName
                      )
                    );
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Number
                  disabled={isView}
                  label={t('DISCOUNT_PER')}
                  value={storeDiscount}
                  onChange={(event: any) => {
                    setStoreDiscount(event.target.value);
                  }}
                  helperMessage={t('PLEASE_ENTER_VALID_DISCOUNT_RETAIL_PRICE')}
                  placeHolder={t('ENTER_DISCOUNT_PER')}
                  required={false}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasySelectLabel
                  disabled={isView}
                  label={t('BACKORDER')}
                  placeholder={t('SELECT_BACKORDER')}
                  size="small"
                  required={false}
                  // statusOptions={BACKORDER}
                  statusOptions={
                    i18n.language === 'fr' ? ['Oui', 'Non'] : ['Yes', 'No']
                  }
                  fullWidth={true}
                  value={selectedBackorder}
                  onChange={(event: any) => {
                    setSelectedBackorder(event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.EmailId
                  label={t('STORE_EMAIL')}
                  disabled={isView}
                  value={storeEmail}
                  onChange={(event: any) => {
                    setStoreEmail(event.target.value);
                  }}
                  helperMessage={t('PLEASE_ENTER_VALID_EMAIL')}
                  placeHolder={t('ENTER_EMAIL_ID')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Work
                  disabled={isView}
                  value={storeWork}
                  onChange={(event: any) => {
                    setStoreWork(prepareMobileNumber(event.target.value));
                  }}
                  helperMessage={t('PLEASE_ENTER_VALID_WORK_NUMBER')}
                  placeHolder={t('ENTER_WORK_PHONE_NUMBER')}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Tax1
                  disabled={isView}
                  value={supplierTax1}
                  onChange={(event: any) => {
                    setSupplierTax1(event.target.value);
                  }}
                  placeHolder={t('ENTER_SUPPLIER_TAX1')}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Tax2
                  disabled={isView}
                  value={supplierTax2}
                  onChange={(event: any) => {
                    setSupplierTax2(event.target.value);
                  }}
                  placeHolder={t('ENTER_SUPPLIER_TAX2')}
                />
              </Grid>
            </Grid>

            <BakeasyDivider />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('CONTACT1')} />
              </Grid>
              <Grid container spacing={2} ml={2}>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.FirstName
                    disabled={isView}
                    value={contactOneFirstName}
                    onChange={(event: any) => {
                      setContactOneFirstName(event.target.value);
                    }}
                    required={true}
                    placeHolder={t('ENTER_FIRST_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.LastName
                    disabled={isView}
                    value={contactOneLastName}
                    onChange={(event: any) => {
                      setContactOneLastName(event.target.value);
                    }}
                    required={true}
                    placeHolder={t('ENTER_LAST_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.EmailId
                    disabled={isView}
                    value={contactOneEmail}
                    onChange={(event: any) => {
                      setContactOneEmail(event.target.value);
                    }}
                    required={true}
                    helperMessage={t('PLEASE_ENTER_VALID_EMAIL')}
                    placeHolder={t('ENTER_EMAIL_ID')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Work
                    disabled={isView}
                    value={contactOneWork}
                    onChange={(event: any) => {
                      setContactOneWork(
                        prepareMobileNumber(event.target.value)
                      );
                    }}
                    helperMessage={t('PLEASE_ENTER_VALID_WORK_NUMBER')}
                    placeHolder={t('ENTER_WORK_PHONE_NUMBER')}
                    required={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Mobile
                    disabled={isView}
                    required={false}
                    value={contactOneMobile}
                    onChange={(event: any) => {
                      setContactOneMobile(
                        prepareMobileNumber(event.target.value)
                      );
                    }}
                    placeHolder={t('ENTER_MOBILE_NUMBER')}
                  />
                </Grid>
              </Grid>
            </Grid>

            <BakeasyDivider />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('CONTACT2')} />
              </Grid>
              <Grid container spacing={2} ml={2}>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.FirstName
                    disabled={isView}
                    required={false}
                    value={contactTwoFirstName}
                    onChange={(event: any) => {
                      setContactTwoFirstName(event.target.value);
                    }}
                    placeHolder={t('ENTER_FIRST_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.LastName
                    disabled={isView}
                    required={false}
                    value={contactTwoLastName}
                    onChange={(event: any) => {
                      setContactTwoLastName(event.target.value);
                    }}
                    placeHolder={t('ENTER_LAST_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.EmailId
                    disabled={isView}
                    required={false}
                    value={contactTwoEmail}
                    onChange={(event: any) => {
                      setContactTwoEmail(event.target.value);
                    }}
                    helperMessage={t('PLEASE_ENTER_VALID_EMAIL')}
                    placeHolder={t('ENTER_EMAIL_ID')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Work
                    disabled={isView}
                    required={false}
                    value={contactTwoWork}
                    onChange={(event: any) => {
                      setContactTwoWork(
                        prepareMobileNumber(event.target.value)
                      );
                    }}
                    helperMessage={t('PLEASE_ENTER_VALID_WORK_NUMBER')}
                    placeHolder={t('ENTER_WORK_PHONE_NUMBER')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Mobile
                    disabled={isView}
                    required={false}
                    value={contactTwoMobile}
                    onChange={(event: any) => {
                      setContactTwoMobile(
                        prepareMobileNumber(event.target.value)
                      );
                    }}
                    placeHolder={t('ENTER_MOBILE_NUMBER')}
                  />
                </Grid>
              </Grid>
            </Grid>

            <BakeasyDivider />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('CONTACT_ACCOUNTING')} />
              </Grid>
              <Grid container spacing={2} ml={2}>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.FirstName
                    disabled={isView}
                    required={false}
                    value={accountingFirstName}
                    onChange={(event: any) => {
                      setAccountingFirstName(event.target.value);
                    }}
                    placeHolder={t('ENTER_FIRST_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.LastName
                    required={false}
                    disabled={isView}
                    value={accountingLastName}
                    onChange={(event: any) => {
                      setAccountingLastName(event.target.value);
                    }}
                    placeHolder={t('ENTER_LAST_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.EmailId
                    disabled={isView}
                    required={false}
                    value={accountingEmail}
                    onChange={(event: any) => {
                      setAccountingEmail(event.target.value);
                    }}
                    helperMessage={t('PLEASE_ENTER_VALID_EMAIL')}
                    placeHolder={t('ENTER_EMAIL_ID')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Work
                    disabled={isView}
                    value={accountingWork}
                    required={false}
                    onChange={(event: any) => {
                      setAccountingWork(
                        prepareMobileNumber(event.target.value)
                      );
                    }}
                    helperMessage={t('PLEASE_ENTER_VALID_WORK_NUMBER')}
                    placeHolder={t('ENTER_WORK_PHONE_NUMBER')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Mobile
                    required={false}
                    disabled={isView}
                    value={accountingMobile}
                    onChange={(event: any) => {
                      setAccountingMobile(
                        prepareMobileNumber(event.target.value)
                      );
                    }}
                    placeHolder={t('ENTER_MOBILE_NUMBER')}
                  />
                </Grid>
              </Grid>
            </Grid>
            <BakeasyDivider />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <BakeasyHeaderLabel message={t('CHAIN_STORE_PARENT')} />
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                <BakeasySwitch
                  disabled={isView}
                  label={'No / Yes'}
                  value={isChainStore}
                  onChange={(event: any) => {
                    event.stopPropagation();
                    setIsChainStore(event?.target?.checked);
                    handleChainStoreCheck(event?.target?.checked);
                  }}
                />
              </Grid>

              {isChainStore && (
                <Grid container ml={2} spacing={2}>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField.Name
                      disabled={isView}
                      label={t('CHAIN_STORE_NAME')}
                      value={chainStoreName}
                      onChange={(event: any) => {
                        setChainStoreName(event.target.value);
                      }}
                      required={true}
                      //placeHolder={t('ENTER_STORE_TAX1')}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    {/* <TextField.Country
                    disabled={isView}
                    label={t('PARENT_COUNTRY')}
                    value={parentCountry}
                    onChange={(event: any) => {
                      setParentCountry(event.target.value);
                    }}
                  /> */}
                    <BakeasyAutoCompleteCountry
                      label={'PARENT_COUNTRY'}
                      value={parentCountry}
                      options={_countryState.value?.data}
                      required={true}
                      onChange={(newValue: any) => {
                        // if (typeof newValue === 'string' && newValue?.length === 0) {
                        //   dispatch(fetchCountries({ page: 1, limit: 5 }));
                        // }

                        // if (typeof newValue === 'string' && newValue?.length > 2) {
                        //   dispatch(fetchCountries({ page: 1, limit: 5, search: newValue }));
                        // }

                        if (typeof newValue === 'object') {
                          handleParentCountrySelect(newValue);
                          setParentPostCode('');
                        }

                        if (newValue === null) {
                          setParentCountry(null);
                          setParentPostCode('');
                          //dispatch(fetchCountries({ page: 1, limit: 5 }));
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    {/* <TextField.State
                    disabled={isView}
                    label={t('PARENT_STATE')}
                    value={parentState}
                    onChange={(event: any) => {
                      setParentState(event.target.value);
                    }}
                    required={true}
                  /> */}
                    <BakeasyAutoCompleteState
                      label={'PARENT_STATE'}
                      // label={parentCountry?.countryName === 'Canada' ? 'PROVINCE' : 'PARENT_STATE'}
                      disabled={parentCountry === null}
                      value={parentState}
                      options={_statesState.value?.data}
                      onChange={async (newValue: any) => {
                        if (typeof newValue === 'object') {
                          setParentState(newValue);
                        }
                        if (newValue === null) {
                          setParentState(null);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField.City
                      disabled={isView}
                      label={t('PARENT_CITY')}
                      value={parentCity}
                      onChange={(event: any) => {
                        setParentCity(event.target.value);
                      }}
                      required={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField.Address
                      disabled={isView}
                      label={t('PARENT_ADDRESS')}
                      value={parentAddress}
                      onChange={(event: any) => {
                        setParentAddress(event.target.value);
                      }}
                      required={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField.Pincode
                      disabled={isView}
                      label={t('PARENT_POSTAL_CODE')}
                      value={parentPostCode}
                      required={true}
                      // onChange={(event: any) => {
                      //   setParentPostCode(preparePostalCode(event.target.value));
                      // }}
                      maxLength={getMaxLengthForPostalCode(
                        parentCountry?.countryName
                      )}
                      regexPattern={getRegexPatternForPostalCode(
                        parentCountry?.countryName
                      )}
                      onChange={(event: any) => {
                        setParentPostCode(
                          preparePostalCode(
                            event.target.value,
                            parentCountry?.countryName
                          )
                        );
                      }}
                      helperMessage={t('PLEASE_ENTER_VALID_PARENT_POSTAL_CODE')}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField.EmailId
                      disabled={isView}
                      label={t('PARENT_EMAIL_ID')}
                      value={parentEmailId}
                      onChange={(event: any) => {
                        setParentEmailId(event.target.value);
                      }}
                      helperMessage={t('PLEASE_ENTER_VALID_PARENT_EMAIL')}
                      required={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField.Work
                      disabled={isView}
                      label={t('PARENT_WORK_NUMBER')}
                      value={parentWork}
                      onChange={(event: any) => {
                        setParentWork(prepareMobileNumber(event.target.value));
                      }}
                      helperMessage={t('PLEASE_ENTER_VALID_PARENT_WORK_NUMBER')}
                      required={true}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>

            <BakeasyDivider />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('BILLING_DETAILS')} />
              </Grid>
              <Grid container spacing={2} ml={2}>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <Dropdown.BillTo
                    options={
                      isChainStore
                        ? BILL_TO_ARRAY
                        : BILL_TO_ARRAY_WITHOUT_CHAINSTORE
                    }
                    disabled={isView}
                    value={selectedBillTo}
                    required={false}
                    onChange={(event: any) => {
                      setSelectedBillTo(event.target.value);
                      setBillToData(event?.target?.value);
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Name
                    disabled={isView}
                    required={false}
                    value={billToName}
                    onChange={(event: any) => {
                      setBillToName(event.target.value);
                    }}
                    placeHolder={t('ENTER_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Name
                    disabled={isView}
                    label={t('COMPANY_NAME')}
                    value={billToCompanyName}
                    onChange={(event: any) => {
                      setBillToCompanyName(event.target.value);
                    }}
                    placeHolder={t('ENTER_COMPANY_NAME')}
                    required={false}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  {/* <TextField.Country
                  disabled={isView}
                  value={billToCountry}
                  onChange={(event: any) => {
                    setBillToCountry(event.target.value);
                  }}
                /> */}
                  <BakeasyAutoCompleteCountry
                    label={'COUNTRY'}
                    value={billToCountry}
                    options={_countryState.value?.data}
                    onChange={(newValue: any) => {
                      // if (typeof newValue === 'string' && newValue?.length === 0) {
                      //   dispatch(fetchCountries({ page: 1, limit: 5 }));
                      // }

                      // if (typeof newValue === 'string' && newValue?.length > 2) {
                      //   dispatch(fetchCountries({ page: 1, limit: 5, search: newValue }));
                      // }

                      if (typeof newValue === 'object') {
                        handleBillToCountrySelect(newValue);
                        setBillToPostCode('');
                      }

                      if (newValue === null) {
                        setBillToCountry(null);
                        setBillToPostCode('');
                        //dispatch(fetchCountries({ page: 1, limit: 5 }));
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  {/* <TextField.State
                  disabled={isView}
                  value={billToState}
                  onChange={(event: any) => {
                    setBillToState(event.target.value);
                  }}
                  required={false}
                /> */}
                  <BakeasyAutoCompleteState
                    label={t('STATE_PROVINCE')}
                    // label={billToCountry?.countryName === 'Canada' ? 'PROVINCE' : 'STATE'}
                    disabled={billToCountry === null}
                    value={billToState}
                    options={_statesState.value?.data}
                    onChange={async (newValue: any) => {
                      if (typeof newValue === 'object') {
                        setBillToState(newValue);
                      }
                      if (newValue === null) {
                        setBillToState(null);
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.City
                    disabled={isView}
                    value={billToCity}
                    onChange={(event: any) => {
                      setBillToCity(event.target.value);
                    }}
                    required={false}
                    placeHolder={t('ENTER_CITY')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Address
                    disabled={isView}
                    label={t('COMPANY_ADDRESS')}
                    value={billToAddress}
                    onChange={(event: any) => {
                      setBillToAddress(event.target.value);
                    }}
                    required={false}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Pincode
                    disabled={isView}
                    value={billToPostCode}
                    required={false}
                    placeHolder={t('ENTER_POSTAL_CODE')}
                    // onChange={(event: any) => {
                    //   setBillToPostCode(preparePostalCode(event.target.value));
                    // }}
                    maxLength={getMaxLengthForPostalCode(
                      billToCountry?.countryName
                    )}
                    regexPattern={getRegexPatternForPostalCode(
                      billToCountry?.countryName
                    )}
                    onChange={(event: any) => {
                      setBillToPostCode(
                        preparePostalCode(
                          event.target.value,
                          billToCountry?.countryName
                        )
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <BakeasyDivider />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <BakeasyHeaderLabel message={t('TAXES')} />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={2} pl={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      {/* <Dropdown.TaxRateOne
                      disabled={isView}
                      value={selectedTaxRate1}
                      onChange={(event: any) => {
                        setSelectedTaxRate1(event.target.value);
                      }}
                    /> */}
                      <BakeasyAutoCompleteTax
                        label="STORE_TAX1"
                        value={selectedTaxRate1}
                        options={
                          _taxesState.value?.data?.length > 0
                            ? _taxesState.value?.data
                            : null
                        }
                        onAddClick={(props: any) => {
                          openAddTaxDialog(props);
                        }}
                        placeholder={t('ENTER_STORE_TAX1')}
                        onChange={(newValue: any) => {
                          if (
                            typeof newValue === 'string' &&
                            newValue?.length > 2
                          ) {
                            if (
                              _taxesState.value?.data?.find(
                                (item: any) => item?.taxName === newValue
                              ) === undefined
                            ) {
                              dispatch(
                                fetchTaxes({
                                  page: 1,
                                  limit: 10,
                                  search: newValue,
                                  countryId: storeCountry?._id,
                                })
                              );
                            }
                          }

                          if (
                            typeof newValue === 'string' &&
                            newValue?.length === 0 &&
                            storeCountry !== null
                          ) {
                            dispatch(
                              fetchTaxes({
                                page: 1,
                                limit: 10,
                                countryId: storeCountry?._id,
                              })
                            );
                          }

                          if (
                            typeof newValue === 'object' &&
                            newValue?.id !== 0
                          ) {
                            setSelectedTaxRate1(newValue);
                          }
                        }}
                        required={false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      {/* <Dropdown.TaxRateTwo
                      disabled={isView}
                      value={selectedTaxRate2}
                      onChange={(event: any) => {
                        setSelectedTaxRate2(event.target.value);
                      }}
                    /> */}
                      <BakeasyAutoCompleteTax
                        label="STORE_TAX2"
                        value={selectedTaxRate2}
                        options={
                          _taxesState.value?.data?.length > 0
                            ? _taxesState.value?.data
                            : null
                        }
                        onAddClick={(props: any) => {
                          openAddTaxDialog(props);
                        }}
                        placeholder={t('ENTER_STORE_TAX2')}
                        onChange={(newValue: any) => {
                          if (
                            typeof newValue === 'string' &&
                            newValue?.length > 2
                          ) {
                            if (
                              _taxesState.value?.data?.find(
                                (item: any) => item?.taxName === newValue
                              ) === undefined
                            ) {
                              dispatch(
                                fetchTaxes({
                                  page: 1,
                                  limit: 10,
                                  search: newValue,
                                  countryId: storeCountry?._id,
                                })
                              );
                            }
                          }

                          if (
                            typeof newValue === 'string' &&
                            newValue?.length === 0 &&
                            storeCountry !== null
                          ) {
                            dispatch(
                              fetchTaxes({
                                page: 1,
                                limit: 10,
                                countryId: storeCountry?._id,
                              })
                            );
                          }

                          if (
                            typeof newValue === 'object' &&
                            newValue?.id !== 0
                          ) {
                            setSelectedTaxRate2(newValue);
                          }
                        }}
                        required={false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      {/* <TextField.Name
                      disabled={isView}
                      label={t('TAX_NUMBER1')}
                      value={taxNumber1}
                      onChange={(event: any) => {
                        setTaxNumber1(event.target.value);
                      }}
                      required={false}
                    /> */}
                      <TextField.Name
                        disabled={true}
                        label={t('STORE_TAX1_RATE')}
                        value={
                          selectedTaxRate1?.taxName
                            ? selectedTaxRate1?.taxName?.split(' - ', 10).pop()
                            : ''
                        }
                        placeHolder={t('ENTER_STORE_TAX1')}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      {/* <TextField.Name
                      disabled={isView}
                      label={t('TAX_NUMBER2')}
                      value={taxNumber2}
                      onChange={(event: any) => {
                        setTaxNumber2(event.target.value);
                      }}
                      required={false}
                    /> */}
                      <TextField.Name
                        disabled={true}
                        label={t('STORE_TAX2_RATE')}
                        value={
                          selectedTaxRate2?.taxName
                            ? selectedTaxRate2?.taxName?.split(' - ', 10).pop()
                            : ''
                        }
                        placeHolder={t('ENTER_STORE_TAX2')}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <BakeasyHeaderLabel message={t('PAYMENT')} />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={2} pl={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <BakeasyAutoCompletePaymentMethod
                        label={t('METHOD')}
                        required={false}
                        value={selectedPaymentMethod}
                        options={_dropdownDataState.value?.data?.PaymentMethod}
                        onChange={async (newValue: any) => {
                          if (typeof newValue === 'object') {
                            setSelectedPaymentMethod(newValue);
                          }
                          if (newValue === null) {
                            setSelectedPaymentMethod(null);
                          }
                        }}
                      />
                      {/* <Dropdown.PaymentMethod
                      disabled={isView}
                      required={false}
                      value={selectedPaymentMethod}
                      onChange={(event: any) => {
                        setSelectedPaymentMethod(event.target.value);
                      }}
                    /> */}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      {/* <Dropdown.PaymentTerms
                      disabled={isView}
                      required={false}
                      value={selectedPaymentTerm}
                      onChange={(event: any) => {
                        setSelectedPaymentTerm(event.target.value);
                      }}
                    /> */}
                      <BakeasyAutoCompletePaymentTerms
                        label={t('TERMS')}
                        required={false}
                        value={selectedPaymentTerm}
                        options={_dropdownDataState.value?.data?.PaymentTerms}
                        onChange={async (newValue: any) => {
                          if (typeof newValue === 'object') {
                            setSelectedPaymentTerm(newValue);
                          }
                          if (newValue === null) {
                            setSelectedPaymentTerm(null);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Dropdown.Status
                        disabled={isView}
                        required={true}
                        options={STATUS_ARRAY}
                        value={selectedStatus}
                        onChange={(event: any) => {
                          setSelectedStatus(event.target.value);
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <BakeasyDivider />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('SHIPPING_DETAILS')} />
              </Grid>

              <Grid container spacing={2} ml={2}>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <Dropdown.ShipTo
                    disabled={isView}
                    value={selectedShipTo}
                    onChange={(event: any) => {
                      setSelectedShipTo(event.target.value);
                      setShipToData(event?.target?.value);
                    }}
                    required={true}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Name
                    disabled={isView}
                    value={shipToName}
                    onChange={(event: any) => {
                      setShipToName(event.target.value);
                    }}
                    placeHolder={t('ENTER_NAME')}
                    required={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Name
                    disabled={isView}
                    label={t('COMPANY_NAME')}
                    value={shipToCompanyName}
                    onChange={(event: any) => {
                      setShipToCompanyName(event.target.value);
                    }}
                    placeHolder={t('ENTER_COMPANY_NAME')}
                    required={true}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  {/* <TextField.Country
                  disabled={isView}
                  value={shipToCountry}
                  onChange={(event: any) => {
                    setShipToCountry(event.target.value);
                  }}
                /> */}
                  <BakeasyAutoCompleteCountry
                    label={'COUNTRY'}
                    required={true}
                    value={shipToCountry}
                    options={_countryState.value?.data}
                    onChange={(newValue: any) => {
                      // if (typeof newValue === 'string' && newValue?.length === 0) {
                      //   dispatch(fetchCountries({ page: 1, limit: 5 }));
                      // }

                      // if (typeof newValue === 'string' && newValue?.length > 2) {
                      //   dispatch(fetchCountries({ page: 1, limit: 5, search: newValue }));
                      // }

                      if (typeof newValue === 'object') {
                        handleShipToCountrySelect(newValue);
                        setShipToPostCode('');
                      }

                      if (newValue === null) {
                        setShipToCountry(null);
                        setShipToPostCode('');
                        //dispatch(fetchCountries({ page: 1, limit: 5 }));
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  {/* <TextField.State
                  disabled={isView}
                  value={shipToState}
                  onChange={(event: any) => {
                    setShipToState(event.target.value);
                  }}
                  required={false}
                /> */}
                  <BakeasyAutoCompleteState
                    label={t('STATE_PROVINCE')}
                    required={true}
                    // label={shipToCountry?.countryName === 'Canada' ? 'PROVINCE' : 'STATE'}
                    disabled={shipToCountry === null}
                    value={shipToState}
                    options={_statesState.value?.data}
                    onChange={async (newValue: any) => {
                      if (typeof newValue === 'object') {
                        setShipToState(newValue);
                      }
                      if (newValue === null) {
                        setShipToState(null);
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.City
                    disabled={isView}
                    value={shipToCity}
                    onChange={(event: any) => {
                      setShipToCity(event.target.value);
                    }}
                    placeHolder={t('ENTER_CITY')}
                    required={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Address
                    disabled={isView}
                    label={t('COMPANY_ADDRESS')}
                    value={shipToAddress}
                    onChange={(event: any) => {
                      setShipToAddress(event.target.value);
                    }}
                    placeHolder={t('ENTER_COMPANY_ADDRESS')}
                    required={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Pincode
                    disabled={isView}
                    value={shipToPostCode}
                    placeHolder={t('ENTER_POSTAL_CODE')}
                    required={true}
                    // onChange={(event: any) => {
                    //   setShipToPostCode(preparePostalCode(event.target.value));
                    // }}
                    maxLength={getMaxLengthForPostalCode(
                      shipToCountry?.countryName
                    )}
                    regexPattern={getRegexPatternForPostalCode(
                      shipToCountry?.countryName
                    )}
                    onChange={(event: any) => {
                      setShipToPostCode(
                        preparePostalCode(
                          event.target.value,
                          shipToCountry?.countryName
                        )
                      );
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} ml={2} mt={0}>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <Dropdown.YesNo
                    disabled={isView}
                    label={t('SHIPPING_CHARGE')}
                    value={selectedShippingCharge}
                    onChange={function (event: any): void {
                      setSelectedShippingCharge(event?.target?.value);
                      setSelectedShippingCalculation('');
                      setShippingCharges('');
                    }}
                    placeholder={t('SELECT_SHIPPING_CHARGES')}
                    required={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <Dropdown.ShippingCalculation
                    disabled={
                      selectedShippingCharge !== 'Yes' &&
                      selectedShippingCharge !== 'Oui'
                        ? true
                        : false
                    }
                    value={selectedShippingCalculation}
                    onChange={(event: any) => {
                      setSelectedShippingCalculation(event?.target?.value);
                    }}
                    required={
                      selectedShippingCharge !== 'Yes' &&
                      selectedShippingCharge !== 'Oui'
                        ? false
                        : true
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <BakeasyTextField
                    label={t('SHIPPING_CHARGES')}
                    disabled={
                      selectedShippingCharge !== 'Yes' &&
                      selectedShippingCharge !== 'Oui'
                        ? true
                        : isView
                    }
                    type="text"
                    placeHolder={t('ENTER_SHIPPING_CHARGES')}
                    name="shippingCharges"
                    fullWidth={true}
                    maxLength={6}
                    value={shippingCharges}
                    onChange={(event: any) => {
                      setShippingCharges(
                        prepareDemicalNumber(event.target.value)
                      );
                    }}
                    regexPattern={Regex.decimalNumber}
                    required={
                      selectedShippingCharge !== 'Yes' &&
                      selectedShippingCharge !== 'Oui'
                        ? false
                        : true
                    }
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} ml={2} mt={0}>
                <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                  <BakeasyAutoCompleteShippingMethod
                    disabled={isView}
                    value={selectedPreferredShippingMethod}
                    options={
                      _shippingMethodsState.value?.data?.length > 0
                        ? _shippingMethodsState.value?.data
                        : null
                    }
                    onAddClick={(props: any) => {
                      openAddShippingMethodDialog(props);
                    }}
                    onChange={(newValue: any) => {
                      if (
                        typeof newValue === 'string' &&
                        newValue?.length > 2
                      ) {
                        dispatch(
                          fetchShippingMethods({
                            page: 1,
                            limit: 5,
                            search: newValue,
                          })
                        );
                      }

                      if (
                        typeof newValue === 'string' &&
                        newValue?.length === 0
                      ) {
                        dispatch(fetchShippingMethods({ page: 1, limit: 5 }));
                      }

                      if (typeof newValue === 'object' && newValue?.id !== 0) {
                        setSelectedPreferredShippingMethod(newValue);
                      }
                    }}
                    required={true}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Dropdown.PreferredShippingMethod
                  disabled={isView}
                  value={selectedPreferredShippingMethod}
                  onChange={function(event: any): void {
                    setSelectedPreferredShippingMethod(event?.target?.value);
                    setPreferredShippingMethod(event?.target?.value);
                  }}
                />
              </Grid> */}

                {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Name
                  label={t('PREFERRED_SHIPPING_METHOD')}
                  required={false}
                  disabled={
                    isView ? true : selectedPreferredShippingMethod === 'Other' ? false : true
                  }
                  value={preferredShippingMethod}
                  onChange={(event: any) => {
                    setPreferredShippingMethod(event.target.value);
                  }}
                />
              </Grid> */}
              </Grid>
            </Grid>
            <BakeasyDivider />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('OTHER_DETAILS')} />
              </Grid>
              <Grid container spacing={2} ml={2}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <TextField.Description
                    disabled={isView}
                    label={t('DESCRIPTION')}
                    type="text"
                    placeHolder={t('ENTER_DESCRIPTION')}
                    name="description"
                    multiline
                    rows={6}
                    value={description}
                    onChange={(event: any) => {
                      setDescription(event.target.value);
                    }}
                    required={false}
                  />
                </Grid>

                {/* conditions for new */}
                {!isEdit && !isView && location?.state.isNew && (
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <BakeasyImgSelector
                      uploadState={'initial'}
                      id="storeLogo"
                      value={selectedStoreLogoFile}
                      label={t('STORE_LOGO')}
                      name="store-logo"
                      headerText={t('ACCEPTED_FORMATS')}
                      footerText={t('PLEASE_UPLOAD')}
                      onChange={(file: any) => {
                        setSelectedStoreLogoFile(file);
                      }}
                    />
                  </Grid>
                )}

                {/* conditions if not logo present through edit and view */}
                {(!isEdit && !isView) ||
                  (isEdit && !storeData?.storeLogo && (
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <BakeasyImgSelector
                        uploadState={'initial'}
                        id="storeLogo"
                        value={selectedStoreLogoFile}
                        label={t('STORE_LOGO')}
                        name="store-logo"
                        headerText={t('ACCEPTED_FORMATS')}
                        footerText={t('PLEASE_UPLOAD')}
                        onChange={(file: any) => {
                          setSelectedStoreLogoFile(file);
                        }}
                      />
                    </Grid>
                  ))}

                {/* conditions if logo present */}
                {(isEdit || isView) && storeData?.storeLogo && (
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <BakeasyImgSelector
                      disabled={isView}
                      uploadState={'initFromProps'}
                      id="storeLogo"
                      value={storeData?.storeLogo}
                      label={t('STORE_LOGO')}
                      name="store-logo"
                      headerText={t('ACCEPTED_FORMATS')}
                      footerText={t('PLEASE_UPLOAD')}
                      onChange={(file: any) => {
                        setSelectedStoreLogoFile(file);
                      }}
                      onClick={() =>
                        openImageDialog(
                          'ViewImage',
                          t('STORE_LOGO'),
                          storeData?.storeLogo
                        )
                      }
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>

            {!isView && (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Grid
                  container
                  sx={{ alignItems: 'end', justifyContent: 'end' }}
                >
                  <Grid margin={1}>
                    <BakeasyButtonCancel
                      onClick={function (
                        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                      ): void {
                        openConfirmDialogMesssageValidation();
                      }}
                    />
                  </Grid>

                  <Grid margin={1}>
                    {isEdit ? (
                      <BakeasyButtonUpdate
                        onClick={() => {
                          onSubmit();
                        }}
                      />
                    ) : (
                      <BakeasyButtonCreate
                        onClick={() => {
                          onSubmit();
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Paper>
        </Grid>
      </div>
    );
  }

  function viewStoreUI() {
    return (
      <Grid>
        <Grid item>
          <BakeasyAppBar
            title={t(
              isEdit ? 'EDIT_STORE' : isView ? 'STORE_DETAILS' : 'ADD_STORE'
            )}
            onBackClick={() => {
              openConfirmDialogMesssageValidation();
            }}
            menus={getMenus()}
          />
        </Grid>

        <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
          <Grid container>
            <BakeasyHeaderLabel message={'STORE_DETAILS'} />
          </Grid>

          <Grid container spacing={2} pl={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('DATE_REGISTERED')}
                value={
                  registrationDate
                    ? dayjs(registrationDate).format('MM/DD/YYYY')
                    : dayjs(new Date()).format('MM/DD/YYYY')
                }
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('STORE_ID')} value={storeId} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('ACCOUNTING_CODE')}
                value={accountingCode}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('LANGUAGE')}
                value={selectedLanguage}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('CATEGORY')}
                value={
                  //selectedCategory
                  selectedCategory
                    ? t(
                        `${selectedCategory?.toUpperCase().replace(/\s+/g, '_')}`
                      )
                    : selectedCategory
                }
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('STORE_NAME')} value={storeName} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('USERNAME')} value={userName} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('LEGAL_NAME')} value={legalName} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('STORE_COUNTRY')}
                value={
                  // storeCountry?.countryName ?? storeCountry

                  storeCountry?.countryName
                    ? t(
                        `${storeCountry?.countryName?.toUpperCase().replace(/\s+/g, '_')}`
                      )
                    : storeCountry?.countryName
                }
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                // label={t('STORE_STATE')}
                // label={storeCountry?.countryName === 'Canada' ? 'STORE_PROVINCE' : 'STORE_STATE'}
                label="STORE_STATE_PROVINCE"
                value={
                  //storeState?.stateName ?? storeState
                  storeState?.stateName
                    ? t(
                        `${storeState?.stateName?.toUpperCase().replace(/\s+/g, '_')}`
                      )
                    : storeState?.stateName
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('STORE_CITY')} value={storeCity} />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('STORE_ADDRESS')}
                value={storeAddress}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('STORE_POSTAL_CODE')}
                value={storePostCode}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('DISCOUNT_PER')}
                value={storeDiscount}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('BACKORDER')}
                value={selectedBackorder}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('EMAIL_ID')} value={storeEmail} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('WORK')} value={storeWork} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('SUPPLIER_TAX1')}
                value={supplierTax1}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('SUPPLIER_TAX2')}
                value={supplierTax2}
              />
            </Grid>
          </Grid>

          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('CONTACT1')} />
            </Grid>
            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('FIRST_NAME')}
                  value={contactOneFirstName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('LAST_NAME')}
                  value={contactOneLastName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('EMAIL_ID')}
                  value={contactOneEmail}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('WORK')} value={contactOneWork} />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('MOBILE')}
                  value={contactOneMobile}
                />
              </Grid>
            </Grid>
          </Grid>

          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('CONTACT2')} />
            </Grid>
            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('FIRST_NAME')}
                  value={contactTwoFirstName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('LAST_NAME')}
                  value={contactTwoLastName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('EMAIL_ID')}
                  value={contactTwoEmail}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('WORK')} value={contactTwoWork} />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('MOBILE')}
                  value={contactTwoMobile}
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <BakeasyHeaderLabel message={t('CONTACT_ACCOUNTING')} />
            </Grid>
            <Grid container spacing={2} style={{ marginLeft: '16px' }}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('FIRST_NAME')}
                  value={accountingFirstName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('LAST_NAME')}
                  value={accountingLastName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('EMAIL_ID')}
                  value={accountingEmail}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('WORK')} value={accountingWork} />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('MOBILE')}
                  value={accountingMobile}
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />

          {isChainStore && (
            <>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <BakeasyHeaderLabel message={t('CHAIN_STORE_PARENT')} />
                </Grid>

                <Grid container ml={2} spacing={2}>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('CHAIN_STORE_NAME')}
                      value={chainStoreName}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_COUNTRY')}
                      value={
                        //parentCountry?.countryName ?? parentCountry
                        parentCountry?.countryName
                          ? t(
                              `${parentCountry?.countryName?.toUpperCase().replace(/\s+/g, '_')}`
                            )
                          : parentCountry?.countryName
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      // label={t('PARENT_STATE')}
                      label={t('PARENT_PROVINCE')}
                      // label={parentCountry?.countryName === 'Canada' ? 'PROVINCE' : 'PARENT_STATE'}
                      value={
                        //parentState?.stateName ?? parentState
                        parentState?.stateName
                          ? t(
                              `${parentState?.stateName?.toUpperCase().replace(/\s+/g, '_')}`
                            )
                          : parentState?.stateName
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_CITY')}
                      value={parentCity}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_ADDRESS')}
                      value={parentAddress}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_POSTAL_CODE')}
                      value={parentPostCode}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_EMAIL_ID')}
                      value={parentEmailId}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_WORK_NUMBER')}
                      value={parentWork}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <BakeasyDivider />
            </>
          )}

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('BILLING_DETAILS')} />
            </Grid>
            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('BILL_TO')}
                  value={
                    selectedBillTo
                      ? t(
                          `${selectedBillTo?.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : selectedBillTo
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('NAME')} value={billToName} />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COMPANY_NAME')}
                  value={billToCompanyName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COUNTRY')}
                  value={
                    //billToCountry?.countryName ?? billToCountry
                    billToCountry?.countryName
                      ? t(
                          `${billToCountry?.countryName?.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : billToCountry?.countryName
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('STATE_PROVINCE')}
                  // label={billToCountry?.countryName === 'Canada' ? 'PROVINCE' : 'STATE'}
                  value={
                    billToState?.stateName
                      ? t(
                          `${billToState?.stateName?.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : billToState?.stateName
                  }
                  //billToState?.stateName ?? billToState}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('CITY')} value={billToCity} />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COMPANY_ADDRESS')}
                  value={billToAddress}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('POSTAL_CODE')}
                  value={billToPostCode}
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('TAXES')} />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('STORE_TAX1')}
                      value={selectedTaxRate1?.taxName ?? selectedTaxRate1}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('STORE_TAX2')}
                      value={selectedTaxRate2?.taxName ?? selectedTaxRate2}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('STORE_TAX1_RATE')}
                      value={
                        selectedTaxRate1?.taxName
                          ? selectedTaxRate1?.taxName?.split(' - ', 10).pop()
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('STORE_TAX2_RATE')}
                      value={
                        selectedTaxRate2?.taxName
                          ? selectedTaxRate2?.taxName?.split(' - ', 10).pop()
                          : ''
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('PAYMENT')} />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('METHOD')}
                      value={
                        selectedPaymentMethod?.paymentMethod
                          ? selectedPaymentMethod?.paymentMethod[i18n.language]
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('TERMS')}
                      value={
                        selectedPaymentTerm?.paymentTerms
                          ? selectedPaymentTerm?.paymentTerms[i18n.language]
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('STATUS')}
                      value={
                        selectedStatus
                          ? t(
                              `${selectedStatus?.toUpperCase().replace(/\s+/g, '_')}`
                            )
                          : selectedStatus
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <BakeasyDivider />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('SHIPPING_DETAILS')} />
            </Grid>

            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('SHIP_TO')}
                  value={
                    selectedShipTo
                      ? t(
                          `${selectedShipTo?.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : selectedShipTo
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('NAME')} value={shipToName} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COMPANY_NAME')}
                  value={shipToCompanyName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COUNTRY')}
                  value={
                    //shipToCountry?.countryName ?? shipToCountry
                    shipToCountry?.countryName
                      ? t(
                          `${shipToCountry?.countryName?.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : shipToCountry?.countryName
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('STATE_PROVINCE')}
                  // label={shipToCountry?.countryName === 'Canada' ? 'PROVINCE' : 'STATE'}
                  value={
                    //shipToState?.stateName ?? shipToState
                    shipToState?.stateName
                      ? t(
                          `${shipToState?.stateName?.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : shipToState?.stateName
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('CITY')} value={shipToCity} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COMPANY_ADDRESS')}
                  value={shipToAddress}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('POSTAL_CODE')}
                  value={shipToPostCode}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} ml={2} mt={0}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('SHIPPING_CHARGE')}
                  value={selectedShippingCharge}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('SHIPPING_CALCULATION')}
                  value={
                    //selectedShippingCalculation
                    selectedShippingCalculation
                      ? t(
                          `${selectedShippingCalculation?.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : selectedShippingCalculation
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('SHIPPING_CHARGES')}
                  value={shippingCharges}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('SHIPPING_METHOD')}
                  value={
                    selectedPreferredShippingMethod?.methodName ??
                    selectedPreferredShippingMethod
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('OTHER_DETAILS')} />
            </Grid>
            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <BakeasyLabelText
                  label={t('DESCRIPTION')}
                  value={description}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <BakeasyImgSelector
                  disabled={isView}
                  uploadState={'initFromProps'}
                  id="storeLogo"
                  value={storeData?.storeLogo}
                  label={t('STORE_LOGO')}
                  name="store-logo"
                  headerText={t('ACCEPTED_FORMATS')}
                  footerText={t('PLEASE_UPLOAD')}
                  onChange={(file: any) => {
                    setSelectedStoreLogoFile(file);
                  }}
                  onClick={() =>
                    openImageDialog(
                      'ViewImage',
                      t('STORE_LOGO'),
                      storeData?.storeLogo
                    )
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    );
  }

  return isView ? viewStoreUI() : addStoreUI();
};
